import { Children } from 'react';
import styled from 'styled-components';
import beTwMerge from '@/utils/beTwMerge';
import colors, { Color, ColorKeys } from '@/styles/colors';
import { luminance } from '@/utils/utils';

interface IInfiniteContainerProps {
  $mobileColumns?: number;
  $tabletColumns?: number;
  $desktopColums?: number;
}

const Container = styled.div<IInfiniteContainerProps>`
  grid-template-columns: repeat(${({ $mobileColumns }) => $mobileColumns}, minmax(0, 1fr));
  @media (min-width: 768px) {
    grid-template-columns: repeat(${({ $tabletColumns }) => $tabletColumns}, minmax(0, 1fr));
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(${({ $desktopColums }) => $desktopColums}, minmax(0, 1fr));
  }
`;

interface MissionGridSectionProps {
  backgroundColor: ColorKeys;
  children: React.ReactNode;
  header?: string;
  mobileColumns?: number;
  tabletColumns?: number;
  desktopColums?: number;
}

export default function MissionGridSection({
  backgroundColor = 'white',
  header,
  children,
  mobileColumns = 1,
  tabletColumns = 4,
  desktopColums = 4,
}: MissionGridSectionProps) {
  const background: Color = colors[backgroundColor];
  const textColorClass = luminance(background.raw) <= 110 ? 'tw-text-color-white' : '';

  return (
    <div
      className={beTwMerge(
        `tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-pt-[56px] lg:tw-pt-[80px] tw-bg-${background.tailwind}`
      )}
    >
      <Container
        className="tw-w-full tw-max-w-[1377px] tw-px-4 lg:tw-px-[35.5px] tw-mb-14 lg:tw-mb-20 tw-grid tw-gap-y-[40px] tw-gap-x-2 md:tw-gap-x-4 lg:tw-gap-x-[35.5px]"
        $mobileColumns={mobileColumns}
        $tabletColumns={tabletColumns}
        $desktopColums={desktopColums}
      >
        {header && (
          <div className="tw-col-span-full tw-flex tw-flex-col tw-gap-6 tw-mx-auto">
            <h2 className="tw-mb-0 tw-text-center h2b">{header}</h2>
          </div>
        )}
        {Children.map(children, (child, index) => (
          <div key={index} className={`tw-col-span-1 ${textColorClass}`}>
            {child}
          </div>
        ))}
      </Container>
    </div>
  );
}
